import { CurrencyEnum } from '~/services/Http';

export const formatCurrency = (currency?: string): string => {
  switch (currency) {
    case CurrencyEnum.EUR: {
      return '€';
    }

    case CurrencyEnum.USD: {
      return '$';
    }

    case CurrencyEnum.SEK: {
      return 'kr';
    }

    default:
      return currency ?? '';
  }
};
